import React from 'react';
import { Hammer } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Descargás el manual',
    desc: 'Lo guardás en tu celular al instante. Lo podés leer en el descanso de la obra, tiene letra grande y clara.'
  }, {
    num: '2',
    title: 'Aplicás la Calculadora',
    desc: 'Usás el Método de Caja Limpia para armar tu próximo presupuesto sin olvidarte de ningún gasto oculto.'
  }, {
    num: '3',
    title: 'Enviás y Cerrás',
    desc: 'Mandás el presupuesto profesional por WhatsApp y cerrás la obra pidiendo el 30% de adelanto con seguridad.'
  }];
  return <section className="py-20 px-4 bg-charcoal text-white" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <div className="flex items-center justify-center gap-4 mb-12" data-id="element-55">
          <Hammer className="h-8 w-8 text-amber" data-id="element-56" />
          <h2 className="font-heading font-bold text-4xl md:text-5xl uppercase text-center" data-id="element-57">
            ¿Cómo funciona?
          </h2>
          <Hammer className="h-8 w-8 text-amber scale-x-[-1]" data-id="element-58" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-59">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-1 bg-stone-700 z-0" data-id="element-60"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-61">
              <div className="w-16 h-16 bg-amber text-charcoal rounded-full flex items-center justify-center font-heading font-bold text-3xl border-4 border-charcoal shadow-hard mb-6" data-id="element-62">
                {step.num}
              </div>
              <h3 className="font-heading font-bold text-2xl uppercase mb-3 text-amber-dark" data-id="element-63">
                {step.title}
              </h3>
              <p className="font-body text-lg text-stone-300" data-id="element-64">{step.desc}</p>
            </div>)}
        </div>

        {/* Proof Block */}
        <div className="mt-20 bg-amber p-8 rounded-sm border-4 border-white text-charcoal text-center transform md:-rotate-1 shadow-hard" data-id="element-65">
          <p className="font-heading font-bold text-2xl md:text-3xl uppercase leading-tight" data-id="element-66">
            En solo 7 días, vas a dejar de dudar cuando te pregunten "¿Cuánto
            sale?".
          </p>
          <p className="font-body text-xl font-medium mt-4" data-id="element-67">
            Vas a pasar de ser "el muchacho que hace arreglos" a ser el
            Contratista que da seguridad. La primera vez que uses este manual
            para cobrar un adicional,{' '}
            <strong className="bg-white px-2 py-1" data-id="element-68">
              el libro se habrá pagado solo 10 veces.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}